"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/page-header/style/css");
var page_header_1 = __importDefault(require("antd/lib/page-header"));
require("antd/lib/descriptions/style/css");
var descriptions_1 = __importDefault(require("antd/lib/descriptions"));
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var utils_1 = require("../../utils");
var auth0_react_1 = require("@auth0/auth0-react");
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var styles = {
    noWrap: {
        whiteSpace: "nowrap"
    },
    preWrap: {
        whiteSpace: "pre-wrap"
    }
};
var ReleaseDetailView = /*#__PURE__*/ react_1.default.memo(function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _useParams = (0, react_router_dom_1.useParams)(), strVersion = _useParams.id;
    var _useAuth = (0, auth0_react_1.useAuth0)(), isAuthenticated = _useAuth.isAuthenticated, getAccessTokenSilently = _useAuth.getAccessTokenSilently;
    var intVersion = parseInt(strVersion, 10);
    var releasesInitialFetch = (0, react_redux_1.useSelector)(function (state) {
        return state.releases.initialFetchDone;
    });
    var releasesFetching = (0, react_redux_1.useSelector)(function (state) {
        return state.releases.isFetching;
    });
    var release = (0, react_redux_1.useSelector)(function (state) {
        return (0, utils_1.findItemByID)(state.releases.items, intVersion, "version");
    });
    var _ref = release !== null && release !== void 0 ? release : {}, version = _ref.version, release_notes = _ref.release_notes, bundle_path = _ref.bundle_path, bundle_size = _ref.bundle_size, submitted_dt = _ref.submitted_dt, published_dt = _ref.published_dt;
    var onBack = (0, react_1.useCallback)(function () {
        return navigate(-1);
    }, [navigate]);
    var title = (0, react_1.useMemo)(function () {
        return !releasesInitialFetch && releasesFetching ? "Loading..." : (0, jsx_runtime_1.jsxs)("span", {
            children: ["Version ", release === null || release === void 0 ? void 0 : release.version]
        });
    }, [releasesInitialFetch, releasesFetching, release]);
    return (0, jsx_runtime_1.jsx)(page_header_1.default, {
        ghost: false,
        onBack: onBack,
        title: title,
        children: (0, jsx_runtime_1.jsxs)(descriptions_1.default, {
            bordered: true,
            size: "small",
            children: [(0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                    label: "Version",
                    children: version !== null && version !== void 0 ? version : ""
                }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                    label: "Submitted",
                    children: (0, jsx_runtime_1.jsx)("span", {
                        style: styles.noWrap,
                        children: new Date(submitted_dt).toLocaleDateString()
                    })
                }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                    label: "Published",
                    children: (0, jsx_runtime_1.jsx)("span", {
                        style: styles.noWrap,
                        children: published_dt ? new Date(published_dt).toLocaleDateString() : "–"
                    })
                }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                    label: "Release Notes",
                    span: 3,
                    children: (0, jsx_runtime_1.jsx)("div", {
                        style: styles.preWrap,
                        children: release_notes !== null && release_notes !== void 0 ? release_notes : ""
                    })
                }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                    label: "Bundle Path",
                    children: (0, jsx_runtime_1.jsx)("a", {
                        onClick: (0, utils_1.downloadVersionBundle)(version, isAuthenticated, getAccessTokenSilently),
                        children: bundle_path !== null && bundle_path !== void 0 ? bundle_path : ""
                    })
                }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                    label: "Bundle Size",
                    children: (0, jsx_runtime_1.jsx)("span", {
                        style: styles.noWrap,
                        children: bundle_size ? "".concat((bundle_size / 1000000).toFixed(1), " MB") : "—"
                    })
                })]
        })
    });
});
exports.default = ReleaseDetailView;
